import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { IApiResponse } from '@core/interfaces/api-response.interface';
import { Observable } from 'rxjs';
import { IAdminUser } from './admin-user-group.interface';

@Injectable({
  providedIn: 'root',
})
export class AdminUsersService {
  private readonly http = inject(HttpClient);

  public getUsers(params?: HttpParams): Observable<IApiResponse<IAdminUser[]>> {
    return this.http.get<IApiResponse<IAdminUser[]>>('users/admin', { params });
  }
}
